import type PptxGenJS from '@meitu/js-to-pptx';
import { pxToInch } from '@/utils/unit-kit';
import type { ILayerProps, ISlide } from '@/version-types';
import { renderLayerContentToCanvas } from './render-to-canvas';

export const renderLayerToPPT = async (slide: ISlide, layer: ILayerProps) => {
    const { left, top, width, height, rotate } = layer;
    const options: PptxGenJS.ImageProps = {
        x: pxToInch(left),
        y: pxToInch(top),
        w: pxToInch(width),
        h: pxToInch(height),
        rotate: rotate > 0 ? rotate : 360 + rotate, // 0 - 360
    };

    const canvas = await renderLayerContentToCanvas(layer, true);

    options.data = canvas?.toDataURL() || '';

    slide.addImage(options);
};
